<script>
    import _        from 'lodash'
    import * as api from '../../shared/api.js'
    import Modal    from '../../shared/SemanticModal.svelte'

    export let item
    export let active
    export let onAction
    
    const min       = 10
    let protocol    = null
    let explanation = null
    let working     = false
    let error       = false
    let checked     = false 
    let reason      = null

    function cancel() {
        protocol = null
        reason   = null
        onAction(false)
    }

    function confirm() {
        working = true        
        const body = { id: item.protocol, reason, explanation }
        return api.post('/inquiry/deny', body)
            .then(api.toJsonIf200)
            .then(inquiry => {
                working  = false
                error    = false
                protocol = null
                onAction(inquiry)
            })
            .catch(err => {
                working = false
                error   = err
                setTimeout(() => { error = false }, 2000)
            })
    }

    function testProtocol(item, protocol) {
        return (item && protocol) ? protocol === item.protocol.substring(0, 5) : false
    }

    function testReason(item, reason, explanation) {
        if(reason === 'OTHER') {
            return explanation && explanation.length >= min
        } else {
            return !!reason
        }
    }

    function missingChars(item, explanation) {
        if(explanation) {
            let missing = min - explanation.length
            return missing > 0 ? missing : 0
        } else {
            return min
        }
    }

    $: protocolReady = testProtocol(item, protocol)
    $: reasonReady   = testReason(item, reason, explanation)
    $: count         = missingChars(item, explanation)
    $: ready         = protocolReady && reasonReady
    $: icon          = protocolReady ? 'green check circle outline' : 'orange question circle outline'
</script>

<style>
    input {
        width: 160px;
    }

    .hide {
        visibility: hidden;
    }
</style>

<Modal {active}>
    <div class="ui tiny modal visible active">
        <div class="header">
            Pedido Negado
        </div>
        <div class="content">
            <h4>
                Digite os 5 primeiros números do protocolo do pedido <b>{ item.protocol }</b>
            </h4>        
            <div class="ui left aligned basic segment">
                <div class:disabled={working} class="ui right icon big input">
                    <input bind:value={ protocol } type="text" placeholder={item.protocol.substring(0, 5)}>
                    <i class="{icon} icon"></i>
                </div>            
            </div>
            <h3 class="ui header">Justificativa</h3>
            <div class="ui left aligned vertical segment">
                <div class="ui toggle big checkbox">
                    <input type="radio" bind:group={reason} value="NOT_FOUND">
                    <label>Não foi possível identificar o titular</label>
                </div>
            </div>
            <div class="ui left aligned vertical segment">
                <div class="ui toggle big checkbox">
                    <input type="radio" bind:group={reason} value="MISSING">
                    <label>Não existem dados disponíveis para o titular</label>
                </div>
            </div>
            <div class="ui left aligned vertical segment">
                <div class="ui toggle big checkbox">
                    <input type="radio" bind:group={reason} value="BLOCKED">
                    <label>Determinação Judicial</label>
                </div>
            </div>
            <div class="ui left aligned vertical segment">
                <div class="ui toggle big checkbox">
                    <input type="radio" bind:group={reason} value="OTHER">
                    <label>Outra</label>
                </div>
                <div class="ui vertical segment">
                    <div class="ui form">
                        <div class="field" class:disabled={working || reason !== 'OTHER'}>
                            <textarea bind:value={explanation} rows="3"></textarea>
                        </div>
                        <div class:hide={count <= 0}>
                            Faltam {count} caracteres
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="actions">
            <button class="ui black button" on:click={cancel}>
                Cancelar
            </button>
            <button class="ui right labeled icon button"
                    class:disabled={working || !ready} 
                    class:loading={working}
                    class:green={!error}
                    class:red={error} 
                    on:click={confirm}>
                Rejeitar<i class="icon" class:check={!error} class:ban={error}/>
            </button>
        </div>
    </div>
</Modal>